"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const VidRaisedHandIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8m3 9H8a3 3 0 0 0-3 3v3.7a9.07 9.07 0 0 0 5.9 2.3 9 9 0 0 0 6.1-2.4V15a3 3 0 0 0-3-3"/><path fill-rule="nonzero" d="M16.6 10.6a1 1 0 0 0 .2 1.4 1.005 1.005 0 0 0 1.402-.203l1.996-2.661c.333-.443.602-1.25.602-1.808V5.005A1 1 0 0 0 19.8 4c-.552 0-1 .45-1 1.002v2.665z"/></g></svg>`
}, props));
VidRaisedHandIcon.displayName = 'VidRaisedHandIcon';
var _default = exports.default = VidRaisedHandIcon;